<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.255H18.42C18.165 15.63 17.39 16.795 16.225 17.575V20.335H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12.4999 22.9998C15.4699 22.9998 17.9599 22.0148 19.7799 20.3348L16.2249 17.5748C15.2399 18.2348 13.9799 18.6248 12.4999 18.6248C9.63492 18.6248 7.20992 16.6898 6.34492 14.0898H2.66992V16.9398C4.47992 20.5348 8.19992 22.9998 12.4999 22.9998Z"
      fill="#34A853"
    />
    <path
      d="M6.345 14.0901C6.125 13.4301 6 12.7251 6 12.0001C6 11.2751 6.125 10.5701 6.345 9.91006V7.06006H2.67C1.9 8.59292 1.49932 10.2847 1.5 12.0001C1.5 13.7751 1.925 15.4551 2.67 16.9401L6.345 14.0901Z"
      fill="#FBBC05"
    />
    <path
      d="M12.4999 5.375C14.1149 5.375 15.5649 5.93 16.7049 7.02L19.8599 3.865C17.9549 2.09 15.4649 1 12.4999 1C8.19992 1 4.47992 3.465 2.66992 7.06L6.34492 9.91C7.20992 7.31 9.63492 5.375 12.4999 5.375Z"
      fill="#EA4335"
    />
  </svg>
</template>

<script>
export default {
  name: "GoogleIcon"
};
</script>
